import { render, staticRenderFns } from "./ErpTemplate.vue?vue&type=template&id=5e4bed32&scoped=true&"
import script from "./ErpTemplate.vue?vue&type=script&lang=js&"
export * from "./ErpTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ErpTemplate.vue?vue&type=style&index=0&id=5e4bed32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4bed32",
  null
  
)

export default component.exports